// @ts-nocheck
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import PageLayout from '@components/PageLayout';
import UpdatePassword from '@components/my-profile/settings/UpdatePassword';
import Subscription from '@components/my-profile/settings/Subscription';
import PersonalizationSettings from '@components/my-profile/settings/PersonalizationSettings';
import PersonalDetailsForm from '@components/my-profile/settings/PersonalDetailsForm';

import * as actions from '@redux-actions/';

import { getUserSettings } from '@services/myProfileServices';
import { getPersonalDetails } from '@services/myProfileServices';

import { getLabelFallback } from '@utils/utils';

const Settings = (): JSX.Element => {
    const settingsPageTitle = getLabelFallback('SETTINGS_PAGE_TITLE');
    const settingsBackLabel = getLabelFallback('SETTINGS_BACK_CTA_LABEL');

    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const personalDetails = useSelector((state: RootState) => state.myProfile.personalDetails);
    const getPersonalDetailsRequestStatus = useSelector(
        (state: RootState) => state.myProfile.personalDetailsRequestStatus
    );

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPersonalDetails(config.mockRequest, config.storeId));
        return () => {
            dispatch(actions.getPersonalDetailsSuccess(null));
        };
    }, []);

    return (
        <PageLayout
            data_element_id="AccountSummary_Profile"
            hideMenu
            labelMenu={settingsPageTitle}
            backLabel={settingsBackLabel}
        >
            <div className="settings">
                {!isMobile && (
                    <div role="region" aria-label="Page title" className="primary-title mb-32">
                        {settingsPageTitle}
                    </div>
                )}
                {getPersonalDetailsRequestStatus === 'SUCCESS' && (
                    <PersonalDetailsForm personalDetails={personalDetails} />
                )}
                <UpdatePassword />
                {getPersonalDetailsRequestStatus === 'SUCCESS' && !!personalDetails && Object.keys(personalDetails.personalizationSettings).length !== 0 && (
                    <PersonalizationSettings
                        personalizationSettings={personalDetails?.personalizationSettings}
                    />
                )}
            </div>
        </PageLayout>
    );
};

export default Settings;
